import API from '@/API/request';

export const cluePoolListApi = {
  // 获取搜索里所有下拉框数据
  getOptionsList: (params) => API.get(`/lead/option_config/details/${params}`),
  // 领取线索
  getClues: (params) => API.post('/lead/lead/customer_receive', params),
  // 获取部门负责人列表
  getDeptStaffList: (id, query) => API.get(`/lead/pool/dept_staff/${id}?param=${query}`),
  // 分配线索
  distribute: (params) => API.post('/lead/lead/distribute', params),
  // 获取线索池/私海池搜索选项列表
  getPoolOptionList: (code, text) => API.post(`/lead/option_config/pool/option`, { poolType: code, keyWord: text }),
  // 下载导入模板
  templateDownload: (params) => API.get('/lead/excel/template'),
  // 线索删除
  deleteLead: (params) => API.post('/lead/lead/delete/batch', params)
};

export const clueDetailsApi = {
  // 获取线索详情数据
  getDetailsData: (params) => API.get(`/lead/lead/details/${params}`),
  // 编辑线索
  editLeadDetails: (params) => API.put('/lead/lead/details', params),
  // 根据大区获取区域列表
  getReginList: (params) => API.get(`/lead/option_config/regin/list/${params}`),
  // 根据区域获取城市列表
  getCityList: (params) => API.get(`/lead/option_config/city/list/${params}`)
};
